import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ExportPDF = cb => async data => {
  const keys = Object.keys(data);
  const values = Object.values(data);
  const keysMap = keys.map((key, index) => [
    { text: key.toUpperCase().replace('_', ' '), style: 'tableHeader' },
    { text: values[index], style: 'text' },
  ]);

  const docDefinition = {
    info: {
      title: data.nome,
      author: 'Semantix Sagitário',
      name: data.nome,
      // subject: 'subject of document',
      // keywords: 'keywords for document',
    },
    content: [
      {
        text: `Informações cadastrais do(a) funcionário(a) ${data.nome}`,
        style: 'header',
      },
      ' ',
      {
        boder: false, // optional
        table: {
          // headers are automatically repeated if the table spans over multiple pages
          // you can declare how many rows should be treated as headers

          headerRows: 1,
          widths: ['*', 'auto'],
          body: keysMap,
        },
        layout: {
          hLineWidth(i, node) {
            return i === 0 || i === node.table.body.length ? 2 : 1;
          },
          vLineWidth(i, node) {
            return i === 0 || i === node.table.widths.length ? 2 : 1;
          },
          hLineColor(i, node) {
            return i === 0 || i === node.table.body.length ? 'black' : 'gray';
          },
          vLineColor(i, node) {
            return i === 0 || i === node.table.widths.length ? 'black' : 'gray';
          },
        },
      },
    ],
    styles: {
      header: {
        fontSize: 14,
        bold: true,
        alignText: 'center',
      },
      subheader: {
        fontSize: 11,
        bold: true,
      },
      tableHeader: {
        fontSize: 11,
        bold: true,
      },
      text: {
        fontSize: 11,
        bold: false,
      },
      quote: {
        italics: true,
      },
      small: {
        fontSize: 8,
      },
    },
  };
  const pdf = await pdfMake
    .createPdf(docDefinition)
    .download(`${data.nome}.pdf`);
  cb(prev => !prev);
  return pdf;
};

export default ExportPDF;
